import { doc, setDoc, Timestamp } from 'firebase/firestore';

import { ActivityLog, ActivityLogAction } from '@/typings/activity-log';
import { getCollection } from '@/utils/firebase';

/**
 * Logs user activity in the Firestore database.
 *
 * @param userId User ID to log the activity for.
 * @param action The action performed by the user, represented as an `ActivityLogAction`.
 * @param context Optional context object containing additional information about the activity.
 */
export async function logUserActivity(
  userId: string,
  action: ActivityLogAction,
  context: Record<string, unknown> = {},
) {
  const collection = getCollection<ActivityLog>('activityLogs');
  const docRef = doc(collection);
  await setDoc(docRef, {
    id: docRef.id,
    userId,
    action,
    context,
    timestamp: Timestamp.now(),
  } satisfies Omit<ActivityLog, 'timestamp'> & { timestamp: Timestamp });
}
